import React from 'react'
import styles from './index.module.scss'
import { Box, Button } from '@mui/material'
import AppLogo from 'src/assets/images/AppIcon.png'
import InputField from 'src/Component/InputField'
import useLogin from './useLogin'
const Login = () => {
  const { email, password, handleEmailChange, handlePasswordChange , handleLoginSubmit} = useLogin()

  return (
    <Box className={styles.loginWrapper}>
      <Box p={2}>
        <img src={AppLogo} alt='AppLogo' height={150} />
      </Box>
      <Box p={2}>
        <form onSubmit={handleLoginSubmit} >
         <Box mb={2}>
         <InputField
            name='email'
            type='email'
            label='Email'
            placeholder='Enter your email.'
            value={email}
            onChange={handleEmailChange}
          />
         </Box>
         <Box mb={2}>
         <InputField
            name='password'
            type='password'
            label='Password'
            placeholder='******'
            value={password}
            onChange={handlePasswordChange}
          />

         </Box>
          <Box textAlign='center'>
            <Button variant='contained' color='primary' type='submit'>
              Log-In
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  )
}

export default Login
